import { TypographyVariantsOptions } from "@mui/material/styles";
import { TypographyStyleOptions } from "@mui/material/styles/createTypography";

declare module "@mui/material/Typography" {
    interface TypographyPropsVariantOverrides {
        caption1: true;
        label: true;
    }
}
declare module "@mui/material/styles" {
    interface TypographyVariantsOptions {
        caption1?: TypographyStyleOptions;
        label?: TypographyStyleOptions;
    }
}

export default {
    fontFamily: "Inter, system-ui, Avenir, Helvetica, Arial, sans-serif",
    fontWeightSemibold: "600",
    h1: { fontSize: "64px", lineHeight: "80px" },
    h2: { fontSize: "48px", lineHeight: "64px" },
    h3: { fontSize: "32px", lineHeight: "48px" },
    h4: { fontSize: "24px", lineHeight: "36px" },
    h5: { fontSize: "20px", lineHeight: "30px" },
    h6: { fontSize: "18px", lineHeight: "28px" },
    subtitle1: { fontWeight: "600", lineHeight: "24px" },
    subtitle2: { fontWeight: "600" },
    caption1: { fontSize: "10px", fontWeight: "500" },
    body2: { lineHeight: "22px" },
    button: { fontWeight: "700" },
    label: { fontWeight: "700", fontSize: "12px", lineHeight: "20px" },
} as TypographyVariantsOptions;
